/* eslint 'jsx-a11y/anchor-is-valid': 'off' */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup, Label, Form, Button } from "reactstrap";
import { Icon } from 'semantic-ui-react';
import { SaveWOReport, GenerateWOReportPDF, UpdateWOReport, GenerateWOReportXLS } from '../../../../action/workorderAction';
import ReportSettings from 'components/EnsembleComponents/WorkOrderComponents/Reports/ReportSettings';
import WorkOrderFilter from "./Filters/WorkOrderFilter";
import PMFilter from "./Filters/PMFilter";
import BuildingFilter from "./Filters/BuildingFilter";
import EngineerFilter from "./Filters/EngineerFilter";
import { setAmplitudeEvent } from 'amplitude/amplitude';

var isEdit = false,reportName,reportDesc,reportType,reportID,ReportTypeName;
var filterDetails = {"Status" : [], "AssignedTo" : [], "Building" : [], "Tenant" : [], "Problem" : [], "Equipment" : []}
const ErrorPadding = {
    color: '#D42D27',
    fontfamily: 'Lato',
    fontStyle: 'italic',
    border: '2px solid #D42D27',
    height: '40px',
    padding: '10px',
    float: 'right',
    marginTop: '-5px'
};
const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};
class CreateReportDetails extends Component {
    constructor(props) {
        super(props);
        reportName = undefined;
        reportDesc = undefined;
        reportType = props.reportType;
        isEdit = props.isEdit;
        let ReportDetails = props.getReportDetails;
        let eStatus = [], eAssignedTo = [], eBuilding = [], eTenant = [], eProblem = [], eEquipment = [], eRecordType = '0';
        if(isEdit && ReportDetails !== undefined && ReportDetails !== null){
            reportID = props.reportID;
            reportName = ReportDetails[0].reportName;
            reportDesc = ReportDetails[0].description;
            reportType = ReportDetails[0].reportType.toString();
            eRecordType = ReportDetails[0].workOrderReportSetting.recordType.toString();
            if(ReportDetails[0].workOrderReportStatus !== null){
                ReportDetails[0].workOrderReportStatus.forEach(el => {
                    eStatus.push({ "id" : el.statusID });
                });
            }
            if(ReportDetails[0].workOrderReportAssignedUsers !== null){
                ReportDetails[0].workOrderReportAssignedUsers.forEach(el => {
                    eAssignedTo.push({ "id" : el.assignedUserID });
                });
            }
            if(ReportDetails[0].workOrderReportBuildings !== null){
                ReportDetails[0].workOrderReportBuildings.forEach(el => {
                    eBuilding.push({ "id" : el.buildingID });
                });
            }
            if(ReportDetails[0].workOrderReportTenants !== null){
                ReportDetails[0].workOrderReportTenants.forEach(el => {
                    eTenant.push({ "id" : el.tenantID });
                });
            }
            if(ReportDetails[0].workOrderReportProblems !== null){
                ReportDetails[0].workOrderReportProblems.forEach(el => {
                    eProblem.push({ "id" : el.problemID });
                });
            }
            if(ReportDetails[0].workOrderReportEquipments !== null){
                ReportDetails[0].workOrderReportEquipments.forEach(el => {
                    eEquipment.push({ "id" : el.equipmentID, "siteId" : el.buildingID });
                });
            }
            
            var lFilters = {
                "Status" : ReportDetails[0].workOrderReportStatus,
                "AssignedTo" : ReportDetails[0].workOrderReportAssignedUsers,
                "Building" : ReportDetails[0].workOrderReportBuildings,
                "Tenant" : ReportDetails[0].workOrderReportTenants,
                "Problem" : ReportDetails[0].workOrderReportProblems,
                "Equipment" : ReportDetails[0].workOrderReportEquipments
            } 
            filterDetails = lFilters;
        }
        this.state = {
            WOFilters : {
                Status: eStatus,
                AssignedTo: eAssignedTo,
                Building: eBuilding,
                Tenant: eTenant,
                Problem: eProblem,
                Equipment: eEquipment,
                RecordType : eRecordType
            },
            error: false,
            isReportNameEmpty: false,
            IsDuplicateReportName: false,
            ISValidReportName: true,
            ISValidReportDesc: true,
            ColorTheme: (isEdit && ReportDetails !== undefined && ReportDetails !== null) ? ReportDetails[0].workOrderReportSetting !== null ? ReportDetails[0].workOrderReportSetting.colorTheme.toString() : "1" : "1",  
            WOperiodType: (isEdit && ReportDetails !== undefined && ReportDetails !== null) ? (ReportDetails[0].workOrderReportPeriod !== null && ReportDetails[0].workOrderReportPeriod.woPeriodType !== null) ? ReportDetails[0].workOrderReportPeriod.woPeriodType.toString() !== "0" ? ReportDetails[0].workOrderReportPeriod.woPeriodType.toString() : "1" :  "1" : "1",
            WOperiodId: (isEdit && ReportDetails !== undefined && ReportDetails !== null) ? (ReportDetails[0].workOrderReportPeriod !== null && ReportDetails[0].workOrderReportPeriod.woPeriod !== null) ? ReportDetails[0].workOrderReportPeriod.woPeriod.toString() !== "0" ? ReportDetails[0].workOrderReportPeriod.woPeriod.toString() : "5" : "5" : "5",
            PMperiodType: (isEdit && ReportDetails !== undefined && ReportDetails !== null) ? (ReportDetails[0].workOrderReportPeriod !== null && ReportDetails[0].workOrderReportPeriod.pmPeriodType !== null) ? ReportDetails[0].workOrderReportPeriod.pmPeriodType.toString() !== "0" ? ReportDetails[0].workOrderReportPeriod.pmPeriodType.toString() : "3" : "3" : "3",
            PMperiodId: (isEdit && ReportDetails !== undefined && ReportDetails !== null) ? (ReportDetails[0].workOrderReportPeriod !== null && ReportDetails[0].workOrderReportPeriod.pmPeriod !== null) ? ReportDetails[0].workOrderReportPeriod.pmPeriod.toString() !== "0" ? ReportDetails[0].workOrderReportPeriod.pmPeriod.toString() : "5" : "5" : "5",
            WOstartDate: (isEdit && ReportDetails !== undefined && ReportDetails !== null) ? ReportDetails[0].workOrderReportPeriod !== null ? ReportDetails[0].workOrderReportPeriod.woStartDate !== "0001-01-01T00:00:00" ? new Date(ReportDetails[0].workOrderReportPeriod.woStartDate) : null : null : null,
            WOendDate: (isEdit && ReportDetails !== undefined && ReportDetails !== null) ? ReportDetails[0].workOrderReportPeriod !== null ? ReportDetails[0].workOrderReportPeriod.woEndDate !== "0001-01-01T00:00:00" ? new Date(ReportDetails[0].workOrderReportPeriod.woEndDate): null : null : null,
            PMstartDate: (isEdit && ReportDetails !== undefined && ReportDetails !== null) ? ReportDetails[0].workOrderReportPeriod !== null ? ReportDetails[0].workOrderReportPeriod.pmStartDate !== "0001-01-01T00:00:00" ? new Date(ReportDetails[0].workOrderReportPeriod.pmStartDate) : null : null : null,
            PMendDate: (isEdit && ReportDetails !== undefined && ReportDetails !== null) ? ReportDetails[0].workOrderReportPeriod !== null ? ReportDetails[0].workOrderReportPeriod.pmEndDate !== "0001-01-01T00:00:00" ? new Date(ReportDetails[0].workOrderReportPeriod.pmEndDate): null : null : null,
            groupById:(isEdit && ReportDetails !== undefined && ReportDetails !== null) ? ReportDetails[0].workOrderReportSetting !== null ? ReportDetails[0].workOrderReportSetting.groupBy.toString() : "0" : "0", 
            isWOStartDateEmpty: false, 
            isWOEndDateEmpty: false,
            isPMStartDateEmpty: false, 
            isPMEndDateEmpty: false,
            isUnChecked: false,            
        }

                
        if(reportType === "1"){
            ReportTypeName =  "Work Order Records";            
        }else if(reportType === "2"){
            ReportTypeName =   "Preventative Maintenance Records";           
        }else if(reportType === "3"){
            ReportTypeName =   "Buildings";            
        }else{
            ReportTypeName =   "Technicians";           
        }

        this.SaveWOReports = this.SaveWOReports.bind(this);
        this.OnFilterSelection = this.OnFilterSelection.bind(this);
        this.MovePrev = this.MovePrev.bind(this);
        this.reportSettingDetails = this.reportSettingDetails.bind(this);
        this.SaveGenaratePDF = this.SaveGenaratePDF.bind(this);
        this.SaveGenarateXLS = this.SaveGenarateXLS.bind(this);
    }

    MovePrev() {
        if(!isEdit)
            this.props.Redirect_To_CreatePage(reportType);
        else
            this.props.Redirect_To_ReportList();
    }

    reportSettingDetails(type,data){
        switch(type){
            case 'ColorTheme':
                        this.setState({ColorTheme:data});
                        break;
            case 'GroupBy':
                            this.setState({groupById: data});
                            break;
            case 'WOPeriodType':
                        this.setState({WOperiodType: data});
                        break;
            case 'WOPeriod':
                        this.setState({WOperiodId: data,isWOStartDateEmpty: false,isWOEndDateEmpty: false});
                        if(data === "10"){
                            this.setState({WOstartDate: null, WOendDate: null})
                        }
                        break;
            case 'PMPeriodType':
                            this.setState({PMperiodType: data});
                            break;
            case 'PMPeriod':
                            this.setState({PMperiodId: data,isPMStartDateEmpty: false,isPMEndDateEmpty: false});
                            if(data === "10"){
                                this.setState({PMstartDate: null, PMendDate: null})
                            }
                            break;
            case 'WOStartDate':
                        this.setState({WOstartDate: data,isWOStartDateEmpty: false});
                        break;
            case 'WOEndDate':
                        this.setState({WOendDate: data,isWOEndDateEmpty: false});
                        break;
            case 'PMStartDate':
                        this.setState({PMstartDate: data,isPMStartDateEmpty: false});
                        break;
            case 'PMEndDate':
                        this.setState({PMendDate: data,isPMEndDateEmpty: false});
                        break;
            default:
                    break;
        }
    }
    
    SaveGenaratePDF = async() => {
        let result = await this.SaveWOReports();
        if(result !== undefined){
            let reportId = {
                "ReportID" : result[0],
                "ReportType" : result[2]
            }
        if(! isEdit)
        setAmplitudeEvent("WO/PM Generate PDF Report",{"Report Type": ReportTypeName , "Page Type" : "Create Page"});
        else
        setAmplitudeEvent("WO/PM Generate PDF Report",{"Report Type": ReportTypeName , "Page Type" : "Edit Page" });

        this.props.GenerateWOReportPDF(reportId,result[1]);
        }         
    }

    SaveGenarateXLS = async() => {
        let result = await this.SaveWOReports();
        if(result !== undefined){
            let reportId = {
                "ReportID" : result[0],
                "ReportType" : result[2]
            }

            if(! isEdit)
            setAmplitudeEvent("WO/PM Generate Excel Report",{"Report Type": ReportTypeName , "Page Type" : "Create Page"});
            else
            setAmplitudeEvent("WO/PM Generate Excel Report",{"Report Type": ReportTypeName , "Page Type" : "Edit Page" });

        this.props.GenerateWOReportXLS(reportId,result[1]);
        } 
    }

    SaveWOReports = async() => {
        this.setState({ error: false, IsDuplicateReportName: false, isReportNameEmpty: false, ISValidReportName: true, ISValidReportDesc: true, isUnChecked: false, isWOStartDateEmpty: false, isWOEndDateEmpty: false, isPMStartDateEmpty: false, isPMEndDateEmpty: false });
        //let preferredfields = this.props.getWorkorderPreferences;
        //let label = this.props.getLabels;
        var RegexRestrictSpecialCharacter =/^[a-zA-Z0-9 ]*$/;
        var RegexRestrictSpecialDescCharacter = /^[^<>;]+$/;
        var IsValid = true, WOreportStartDate = new Date(), WOreportEndDate = new Date(), PMreportStartDate = new Date(), PMreportEndDate = new Date();
        var lReportName = (this.refs.report_name_in_input.value).trim(); //Report Name Validation
        var lReportDesc = (this.refs.WO_Report_Description.value).trim(); 
        if (lReportName === null || lReportName === ""){
            this.setState({isReportNameEmpty: true});
            IsValid = false;
        }
        if(!lReportName.match(RegexRestrictSpecialCharacter)){
            this.setState({ISValidReportName: false});
            IsValid = false;
        }
        if(!lReportDesc.match(RegexRestrictSpecialDescCharacter)){
            this.setState({ISValidReportDesc: false});
            IsValid = false;
        }

        let lstReports = this.props.getWorkOrderReportsList;
        if (lstReports !== undefined && lstReports !== null && lstReports.length > 0) {
            lstReports = lstReports.filter(function (item) {
                return lReportName.toUpperCase() === item.reportName.toUpperCase()
            });
            if (lstReports !== null && lstReports.length > 0) {
                if (lstReports[0].reportName !== reportName) { //Update Reports Scenario
                    IsValid = false;
                    this.setState({ IsDuplicateReportName: true });
                }
            }
        }

        if(reportType !== "2" && this.state.WOperiodId === "10"){ //Start and End Date Validation
            //WO Start Date Validation
            if(reportType === "1" && this.state.WOstartDate === null){
                this.setState({isWOStartDateEmpty: true});
                IsValid = false;
            }
            else if(reportType !== "1" && this.state.WOFilters.RecordType !== "2" && this.state.WOstartDate === null){
                this.setState({isWOStartDateEmpty: true});
                IsValid = false;
            }else{
                var startDate = new Date(this.state.WOstartDate);
                WOreportStartDate = (startDate.getMonth() + 1) + "/" + startDate.getDate() + "/" + startDate.getFullYear();
            }

            //WO End Date Validation
            if(reportType === "1" && this.state.WOendDate === null){
                this.setState({isWOEndDateEmpty: true});
                IsValid = false;
            }
            else if(reportType !== "1" && this.state.WOFilters.RecordType !== "2" && this.state.WOendDate === null){
                this.setState({isWOEndDateEmpty: true});
                IsValid = false;
            }
            else{
                var endDate = new Date(this.state.WOendDate);
                WOreportEndDate = (endDate.getMonth() + 1) + "/" + endDate.getDate() + "/" + endDate.getFullYear();
            }
        }
        if(reportType !== "1" && this.state.PMperiodId === "10"){ //Start and End Date Validation
            //PM Start Date Validation
            if(reportType === "2" && this.state.PMstartDate === null){
                this.setState({isPMStartDateEmpty: true});
                IsValid = false;
            }
            else if(reportType !== "2" && this.state.WOFilters.RecordType !== "1" && this.state.PMstartDate === null){
                this.setState({isPMStartDateEmpty: true});
                IsValid = false;
            }
            else{
                var startDate1 = new Date(this.state.PMstartDate);
                PMreportStartDate = (startDate1.getMonth() + 1) + "/" + startDate1.getDate() + "/" + startDate1.getFullYear();
            }

            //PM End Date Validation
            if(reportType === "2" && this.state.PMendDate === null){
                this.setState({isPMEndDateEmpty: true});
                IsValid = false;
            }
            else if(reportType !== "2" && this.state.WOFilters.RecordType !== "1" && this.state.PMendDate === null){
                this.setState({isPMEndDateEmpty: true});
                IsValid = false;
            }
            else{
                var endDate1 = new Date(this.state.PMendDate);
                PMreportEndDate = (endDate1.getMonth() + 1) + "/" + endDate1.getDate() + "/" + endDate1.getFullYear();
            }
        }

        if(this.state.WOFilters.RecordType === '-1'){
            IsValid = false;
            this.setState({isUnChecked: true});
        }

        var StatusFilters = [], AssignedToFilters = [], BuildingFilters = [], TenantFilters = [], ProblemFilters = [], EquipmentFilters = [], lWorkOrderReportSetting = {};

        this.state.WOFilters.Status.forEach(el => {
            StatusFilters.push({ "StatusID": el.id });
        });
        this.state.WOFilters.AssignedTo.forEach(el => {
            AssignedToFilters.push({ "AssignedUserID": el.id });
        });
        this.state.WOFilters.Building.forEach(el => {
            if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length){
                var lBuilding = this.props.getWorkOrderBuildings.filter(x => x.id === el.id);
                if(lBuilding[0] !== undefined && lBuilding[0] !== null && !lBuilding[0].isDeleted)
                    BuildingFilters.push({ "BuildingID": el.id });
            }
        });
        this.state.WOFilters.Tenant.forEach(el => {
            TenantFilters.push({ "TenantID": el.id });
        });
        this.state.WOFilters.Problem.forEach(el => {
            ProblemFilters.push({ "ProblemID": el.id });
        });
        this.state.WOFilters.Equipment.forEach(el => {
            if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length){
                var l_Building = this.props.getWorkOrderBuildings.filter(x => x.id === el.siteId);
                if(l_Building[0] !== undefined && l_Building[0] !== null && !l_Building[0].isDeleted)
                    EquipmentFilters.push({ "BuildingID": el.siteId, "EquipmentID": el.id });
            }
        });

        lWorkOrderReportSetting = {
            "GroupBy": (reportType !== "3" && reportType !== "4") ? this.state.groupById : (reportType === "3") ? "3" : "2",
            "RecordType": this.state.WOFilters.RecordType,
            "ColorTheme": this.state.ColorTheme
        }

        var lWorkOrderReportPeriod = {
            "WOPeriodType" : this.state.WOperiodType,
            "PMPeriodType" : this.state.PMperiodType,
            "WOPeriod" : this.state.WOperiodId,
            "PMPeriod" : this.state.PMperiodId,
            "WOStartDate" : WOreportStartDate,
            "PMStartDate" : PMreportStartDate,
            "WOEndDate" : WOreportEndDate,
            "PMEndDate" : PMreportEndDate
        }

        if (IsValid) {
            let lineitem = {
                "ReportName": lReportName,
                "ReportType": reportType,
                "Description": this.refs.WO_Report_Description.value,
                "WorkOrderReportSetting": lWorkOrderReportSetting,
                "WorkOrderReportPeriod": lWorkOrderReportPeriod,
                "WorkOrderReportStatus": StatusFilters,
                "WorkOrderReportAssignedUsers": AssignedToFilters,
                "WorkOrderReportBuildings": BuildingFilters,
                "WorkOrderReportTenants": TenantFilters,
                "WorkOrderReportProblems": ProblemFilters,
                "WorkOrderReportEquipments":EquipmentFilters
            }

             if(!isEdit){
                setAmplitudeEvent("WO/PM Create New Report",{"Report Type": ReportTypeName });
                 const id = await this.props.SaveWOReport(lineitem);
                 this.props.Redirect_To_ReportList();
                 return ([id,lReportName,reportType]);              
                 
             }else{
                setAmplitudeEvent("WO/PM Edit Report",{"Report Type": ReportTypeName });
                 await this.props.UpdateWOReport(lineitem,reportID);
                 this.props.Redirect_To_ReportList();
                 return ([reportID,lReportName,reportType]);
             }            
        } else {
            this.setState({ error: true });
        }
    }

    OnFilterSelection(SelectedData){
        let WoFilterData;
        WoFilterData = this.state.WOFilters;
        if (SelectedData.Type === "Status")
            WoFilterData.Status = SelectedData.Ids;
        if (SelectedData.Type === "AssignedTo")
            WoFilterData.AssignedTo = SelectedData.Ids;
        if (SelectedData.Type === "Building")
            WoFilterData.Building = SelectedData.Ids;
        if (SelectedData.Type === "Tenant")
            WoFilterData.Tenant = SelectedData.Ids;
        if (SelectedData.Type === "Problem")
            WoFilterData.Problem = SelectedData.Ids;
        if (SelectedData.Type === "Equipment")
            WoFilterData.Equipment = SelectedData.Ids;
        if (SelectedData.Type === "RecordType") 
            WoFilterData.RecordType = SelectedData.Value;
        this.setState({ WOFilters: WoFilterData });
    }

    render() {
        let label = this.props.getLabels;
        var FilterContent;var headertext;
        var errormsg;
        if (this.state.error) {
            errormsg = <p style={ErrorPadding} >
                <Icon name='exclamation triangle' style={ErrorSign} />
                <b>Please correct all errors before continuing.</b>
            </p>
        }

        

        switch(reportType){
            case "1" : 
                FilterContent = WorkOrderFilter;
                headertext = "WO";
                break;
            case "2" : 
                FilterContent = PMFilter;
                headertext = "PM";
                break;
            case "3" : 
                FilterContent = BuildingFilter;
                headertext = "Building";
                break;
            case "4" : 
                FilterContent = EngineerFilter;
                headertext = "Technician";
                break;
            default :
                FilterContent = WorkOrderFilter;
                headertext = "WO";
                break;
        }

        return (
            <div className={this.props.Premise ? "main_container" : "cloud_main_container"}>
                <div className="border_container">
                    <div className="main_container">
                        <Label id="button_back" style={{ "color": "#2070CF", "cursor": "pointer", fontSize: "15px", fontFamily: "Lato" }} onClick={this.MovePrev}>{"< Back"}</Label>
                        <Form>
                            <FormGroup row>
                                <Col sm={{ size: 12 }}>
                                    { !isEdit ? <Label className="reportsHeaderlbl">Create New {headertext} Report</Label> : <Label id="label_editreport" className="reportsHeaderlbl">Edit {headertext} Report</Label> }
                                </Col>
                            </FormGroup>
                        </Form>
                        <div className="row row_padding">
                            <div className="col-md-6">
                                <Form>
                                    <FormGroup row>
                                        <Col sm={{ size: 12 }}>
                                            <Label id="label_details" className="reportsHeaderlbl">Details</Label>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col sm={{ size: 12 }}>
                                            <Label id="label_reportname" style={{ marginBottom: "0px" }} className={(this.state.isReportNameEmpty || this.state.IsDuplicateReportName || !this.state.ISValidReportName) ? "errortext workorderlbl" : "workorderlbl"}>Report Name*</Label><br />
                                            <input id="input_reportname" type="text" aria-label="report-name-input" ref='report_name_in_input' maxLength="50" style={(this.state.error) ? { width: '90%' } : { width: '100%' }} className={(this.state.isReportNameEmpty || this.state.IsDuplicateReportName || !this.state.ISValidReportName) ? "errorhighlight pm_textbox" : "pm_textbox"} defaultValue={reportName}/>
                                            <span hidden={(!this.state.isReportNameEmpty) && (!this.state.IsDuplicateReportName) && (this.state.ISValidReportName)}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                                <Label style={{ 'color': '#D42D27', fontStyle: 'italic', fontSize: '10px', fontFamily: 'Lato' }}><b>{this.state.IsDuplicateReportName ? "Duplicate Report Name" : !this.state.ISValidReportName ? "Enter valid Report Name" : this.state.isReportNameEmpty ? "An entry is required" : ""}</b></Label></span>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row style={{paddingBottom: "20px"}}>
                                        <Col sm={{ size: 12 }}>
                                            <Label id="label_description" style={{ marginBottom: "0px" }} className={(!this.state.ISValidReportDesc) ? "errortext workorderlbl" : "workorderlbl"}>Description</Label><br />
                                            <textarea id="input_description" aria-label="report-desc-input" ref='WO_Report_Description' style={{ width: '100%', 'resize': 'none' }} rows="7" maxLength="100" className={(!this.state.ISValidReportDesc ? "errorhighlight workorderedit-textarea workorderheaderlbl" : "workorderedit-textarea workorderheaderlbl")} defaultValue={reportDesc}/>
                                        </Col>
                                    </FormGroup>
                                </Form>
                            </div>
                            <div className="col-md-1 vertical-line"></div>
                            <div className="col-md-5">
                                <ReportSettings reportType={reportType} reportSetting={this.reportSettingDetails} dateValidation={[this.state.isWOStartDateEmpty,this.state.isWOEndDateEmpty,this.state.isPMStartDateEmpty,this.state.isPMEndDateEmpty]} dataValue={[this.state.WOstartDate,this.state.WOendDate,this.state.PMstartDate,this.state.PMendDate,this.state.WOperiodType,this.state.WOperiodId,this.state.PMperiodType,this.state.PMperiodId,this.state.ColorTheme,this.state.groupById]}/>
                            </div>
                        </div>
                            <hr style={{backgroundColor:'#666666', border:'none', height:'1px' }} />
                            <FormGroup row style={{paddingBottom: "20px"}}>
                                <Col sm={{ size: 12 }}>
                                    { (reportType === "3" || reportType === "4") ? <FilterContent FilterSelection={this.OnFilterSelection} SavedData={filterDetails} IsEdit={isEdit} isUnChecked={this.state.isUnChecked} reportSetting={this.reportSettingDetails} dateValidation={[this.state.isWOStartDateEmpty,this.state.isWOEndDateEmpty,this.state.isPMStartDateEmpty,this.state.isPMEndDateEmpty]} dataValue={[this.state.WOstartDate,this.state.WOendDate,this.state.PMstartDate,this.state.PMendDate,this.state.WOperiodType,this.state.WOperiodId,this.state.PMperiodType,this.state.PMperiodId,this.state.ColorTheme,this.state.groupById,this.state.WOFilters.RecordType]}/> 
                                    : <FilterContent FilterSelection={this.OnFilterSelection} SavedData={filterDetails} IsEdit={isEdit} reportSetting={this.reportSettingDetails} dateValidation={[this.state.isWOStartDateEmpty,this.state.isWOEndDateEmpty,this.state.isPMStartDateEmpty,this.state.isPMEndDateEmpty]} dataValue={[this.state.WOstartDate,this.state.WOendDate,this.state.PMstartDate,this.state.PMendDate,this.state.WOperiodType,this.state.WOperiodId,this.state.PMperiodType,this.state.PMperiodId,this.state.ColorTheme,this.state.groupById]} /> }
                                </Col>
                            </FormGroup>   
                    </div>
                    <div style={{ marginBottom: '-50px', position: 'relative', height: '30px' }}>
                        <span className="workorderlbl-noentry" style={{position: 'absolute', bottom:'-2px', left:'15px'}}>*required fields </span> 
                        <Button id="dropdown_cancel" className="reports_btn_cancel" style={{ 'float': 'right', marginLeft: '6px', background: '#BBBBBB 0% 0% no-repeat padding-box' }} onClick={() => { this.props.Redirect_To_ReportList() }}>{label['PreventativeMaintenance.Button.Cancel.Text']}</Button>
                        <div className="ASUdropdown" style={{ float: 'right', marginLeft: '8px' }}>
                            <button id="dropdown_save" type="button" className="ASUdropbtn"><span className="ASUdropdowntxt">SAVE</span><i className="arrowi down" style={{ float: 'right' }}></i></button>
                            <div id="dropdown_save" className="ASUdropdown-content" style={{ position: 'relative' }}>
                                <a id="link_saveandclose" onClick={this.SaveWOReports}>{"Save and Close"}</a>
                                <a id="link_saveandgeneratepdf" onClick={this.SaveGenaratePDF}>{"Save and Generate PDF"}</a>
                                <a id="link_saveandgeneratexls" onClick={this.SaveGenarateXLS}>{"Save and Generate XLS"}</a>
                            </div>
                        </div>
                        {errormsg}
                    </div>
                </div>
            </div>
        )
    };
};

const mapStateToProps = (state) => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkOrderReportsList: state.WorkorderRootReducer.WorkorderReportsList,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getTenantList: state.tenantsRootReducer.TenantsList,
        getBuildingEquipments: state.WorkorderRootReducer.BuildingsEquipments,
        getEquipments: state.WorkorderRootReducer.WorkorderEquipments,
        getReportDetails: state.WorkorderRootReducer.WorkorderReportsDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        SaveWOReport: (Data) => dispatch(SaveWOReport(Data)),
        GenerateWOReportPDF: (reportID,reportName) => dispatch(GenerateWOReportPDF(reportID,reportName)),
        GenerateWOReportXLS: (reportID,reportName) => dispatch(GenerateWOReportXLS(reportID,reportName)),
        UpdateWOReport: (Data,id) => dispatch(UpdateWOReport(Data,id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateReportDetails);